import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import Hero from './Hero/Hero';
import People from './People/People';
import Video from './Video/Video';
import ValuesCarousel from './ValuesCarousel/ValuesCarousel';
import Benefits from './Benefits/Benefits';
import SloganDifferent from './SloganDifferent/SloganDifferent';

export const CareersLanding = ({ homepageCareers, people, isDesktop }) => (
    <div className="careers-landing">
        <Helmet>
            <title>Hudson Pacific Properties Careers | Hudson Pacific Properties</title>
            <meta name="description" property="og:description" content="Hudson Pacific looks to employ highly-motivated self-starters with exceptional integrity and a commitment to delivering outstanding work product. In return, we offer a comprehensive compensation and benefits package, as well as programs focused on employees? wellness, community involvement and work-life balance." />
        </Helmet>
        <Hero />
        {people && <People people={people} />}
        <section className="section carrier-bg-pattern">
        { <ValuesCarousel isDesktop={isDesktop} /> }
        {/* <Video /> */}
        </section>
        <SloganDifferent />

        <Benefits />
    </div>
);

CareersLanding.propTypes = {
    people: PropTypes.array,
    homepageCareers: PropTypes.array,
    isDesktop: PropTypes.bool,
};

export default connect(
    ({ content }) => ({
        caseStudies: content.caseStudies,
        homepageCareers: content.homepageCareers,
        people: content.people,
    }),
    state => ({
        isDesktop: state.screen ? state.screen.isDesktop : true,
    }),
    null
)(CareersLanding);
